module.exports = __webpack_public_path__ + "static/media/grid.02a4c1d2.svg";